module.exports = __webpack_public_path__ + "static/NoPicF-2e7729fa51874a66a1cedc930ea00ad7.jpg";